<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div>
      <div class="row">
        <keep-alive>
          <b-card v-bind="cardAttrs" :title="undefined" :sub-title="undefined">
            <slot>
              <div class="row">
                <div class="col-md-6 row">
                  <div class="col-md-12">
                    <div class="label">No Laporan Penjualan</div>
                    <div class="value">
                      <router-link :to="`/sale_notes/${model.sale_order.id}`">
                        {{model.sale_order.id}}
                      </router-link>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="label">Tanggal Nota Bongkar</div>
                    <div class="value">
                      {{$moment.utc(model.sale_order.ordered_at).local().format('DD MMM YYYY')}}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="label">Pabrik</div>
                    <div class="value">
                      {{model.manufacture.name}}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="label">Nominal Balancing</div>
                    <div class="value">
                      {{ $numeral(Math.abs(model.profit_share.total)).format('$ 0,0') }}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="label">Penyesuaian</div>
                    <div class="value">Value</div>
                  </div>
                  <div class="col-md-12">
                    <div class="label">Setelah Penyesuaian</div>
                    <div class="value">Value</div>
                  </div>
                </div>
                <div class="col-md-6 row">
                  <div class="col-md-12">
                    <div class="label">No Folder</div>
                    <div class="value">
                      <router-link :to="`/tickets/${model.sale_order.ticket_id}`">
                        {{model.sale_order.ticket_id}}
                      </router-link>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="label">No Nota Bongkar</div>
                    <div class="value">
                      <router-link :to="`/unloads/${model.sale_order.id}`">
                        {{model.sale_order.id}}
                      </router-link>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="label">Mitra</div>
                    <div class="value">
                      {{model.customer.name}}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="label">Status Pembayaran</div>
                    <div class="value">Value</div>
                  </div>
                  <div class="col-md-12">
                    <div class="label">Catatan</div>
                    <div class="value">Value</div>
                  </div>
                  <div class="col-md-12">
                    <div class="label">Setelah Penyesuaian</div>
                    <div class="value">Value</div>
                  </div>
                </div>
              </div>
            </slot>
            <slot name="card-footer">
              <div class="h-100 d-flex justify-content-end align-items-end p-2" v-if="!denyFooter">
                <div>
                  <div class="row d-print-none px-2">
                    <div class="col-12 d-flex flex-row-reverse justify-content-start flex-wrap">
                      <b-button
                          v-if="printable"
                          @click="handlePrint"
                          class="btn btn-success waves-effect waves-light me-1 ms-2"
                      ><i class="fa fa-print"></i>Print
                      </b-button>
                      <b-button class="ms-2" native-type="submit"
                                variant="outline-danger" >
                        {{ $t('Delete') }}
                      </b-button>
                      <b-button class="ms-2" variant="link" >
                        {{ $t('Back') }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </b-card>
        </keep-alive>
      </div>
    </div>
  </Layout>
</template>
<script>
import ModelShow from '../models/show';

export default {
  extends: ModelShow,
  page: {
    title: "Detail Bank Accounts",
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t('balancings.singular'))
      }
    },
    resourceRoute: {default: 'balancings'},
    modelVariable: {default: 'balancing'},
    denyDelete: {type: Boolean, default: true},
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('balancings.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('balancings.plural')),
          href: "/balancings",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/balancings/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [
        {
          key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.customer`)),
          value: this.model.customer.name,
        },
        {
          key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.bank`)),
          value: this.model.bank.name
        },
        {
          key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.account_number`)),
          value: this.model.account_number,
        }
      ]
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/balancing_transactions/${this.$route.params.key}`, {
        params: {
          with: [
            'sale_order',
            'customer',
            'profit_share',
            'manufacture',
          ].join(','),
          'profit_share[total__gt]': 0,
        }
      }).then((response) => {
        const {data: {data}} = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error)).finally(() => this.loading = false)
    }
  }
}
</script>


<style lang="scss" scoped>
  .label {
    color: var(--neutral-800, var(--colors-slate-800, #1E293B));
    font-size: 13px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.26px;
  }

  .value {
    color: var(--neutral-600, var(--colors-slate-600, #475569));
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-block: 4px;
    margin-bottom: 12px;
  }
</style>